export default __webpack_public_path__ + "media/projects/chat-avatar-2f4dfc0c.jpg";